import React from "react";

function Content({ children }) {
  return <div id="content">{children}</div>;
}

export default Content;
